import { type MetaFunction } from '@remix-run/node'
import { Logo } from '#app/components/logo'
import { Button } from '#app/components/ui/button.tsx'
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '#app/utils/mobile-app-links.ts'

export const meta: MetaFunction = () => [{ title: 'Get the Choros app' }]

// Browsers that follow an app link land here (server/utils/deep-link-host.ts):
// members can only use Choros in the mobile app for now
export default function OpenInAppRoute() {
	return (
		<main className="container mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-6 px-4 py-16 text-center">
			<Logo size="lg" />
			<h1 className="text-3xl font-bold tracking-tight">
				Open Choros on your phone
			</h1>
			<p className="text-base text-muted-foreground">
				Choros lives in the mobile app for now. The web version is coming.
			</p>
			<div className="flex w-full flex-col gap-3">
				<Button asChild size="lg" textSize="base">
					<a href={APP_STORE_URL}>Get it on the App Store</a>
				</Button>
				<Button asChild size="lg" textSize="base" variant="outline">
					<a href={GOOGLE_PLAY_URL}>Get it on Google Play</a>
				</Button>
			</div>
			<p className="text-sm text-muted-foreground">
				Already have the app? Open it from your home screen.
			</p>
		</main>
	)
}
